import { Box, Stack, Typography } from "@mui/material";

import LearnVisualFrame from "./LearnVisualFrame";

const segmentColor = {
  measured: "rgba(201, 176, 123, 0.88)",
  indicated: "rgba(201, 176, 123, 0.48)",
  inferred: "rgba(34, 35, 37, 0.12)",
};

function MixBar({ label, total, segments, note }) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 0.75 }}>
        <Typography sx={{ fontSize: 13.5, fontWeight: 900 }}>{label}</Typography>
        <Typography sx={{ fontSize: 12.5, color: "text.secondary", fontWeight: 750 }}>{total}</Typography>
      </Stack>
      <Box
        sx={{
          display: "flex",
          height: 34,
          overflow: "hidden",
          border: "1px solid rgba(34, 35, 37, 0.14)",
          borderRadius: 1,
          backgroundColor: "#fff",
        }}
      >
        {segments.map((segment) => (
          <Box
            key={segment.label}
            sx={{
              width: `${segment.percent}%`,
              minWidth: segment.percent <= 8 ? 18 : 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: 0.5,
              backgroundColor: segmentColor[segment.type],
              borderRight: "1px solid rgba(255,255,255,0.7)",
              fontSize: 11.5,
              lineHeight: 1,
              fontWeight: 900,
              color: "text.primary",
              whiteSpace: "nowrap",
            }}
          >
            {segment.label}
          </Box>
        ))}
      </Box>
      <Typography sx={{ mt: 0.65, fontSize: 12.5, color: "text.secondary", fontWeight: 750 }}>
        {note}
      </Typography>
    </Box>
  );
}

export default function ClassificationMixVisual({ title, takeaway, caption, data = {} }) {
  const rows = data.rows || [
    {
      label: "Hypothetical Company A",
      total: "10 Moz total",
      note: "Mostly Inferred",
      segments: [
        { type: "measured", label: "M", percent: 5 },
        { type: "indicated", label: "Indicated", percent: 20 },
        { type: "inferred", label: "Inferred", percent: 75 },
      ],
    },
    {
      label: "Hypothetical Company B",
      total: "10 Moz total",
      note: "Mixed confidence base",
      segments: [
        { type: "measured", label: "Measured", percent: 20 },
        { type: "indicated", label: "Indicated", percent: 45 },
        { type: "inferred", label: "Inferred", percent: 35 },
      ],
    },
    {
      label: "Hypothetical Company C",
      total: "10 Moz total",
      note: "Mostly Measured & Indicated",
      segments: [
        { type: "measured", label: "Measured", percent: 35 },
        { type: "indicated", label: "Indicated", percent: 55 },
        { type: "inferred", label: "Inf.", percent: 10 },
      ],
    },
  ];

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="compact">
      <Stack spacing={2}>
        {rows.map((row) => (
          <MixBar key={row.label} {...row} />
        ))}
      </Stack>
    </LearnVisualFrame>
  );
}
